import { Text } from "@mantine/core";
import React from "react";

const ChatHeatMap: React.FC = () => {
  return <Text>Anal - Chat Heat Map</Text>;
};

export default ChatHeatMap;
